var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-box"},[_c('div',{staticClass:"home-items home-items--col"},[_c('Entrance'),_c('Assistant')],1),_c('div',{staticClass:"home-items home-items--fill"},[_c('Backlog'),_c('div',{staticClass:"home-bottom-row"},[_c('Rules'),_c('Journalism')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }